<template>
  <!-- <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    <el-date-picker v-model="currentField.componentValue" type="date" placeholder="Pick a day"
     v-on:change="datePickerChange"
    ></el-date-picker>
  </el-form-item> -->
  <div class="date-pick el-form-item pdf-item" :componentvalue="formattedValue">
    <el-form-item
        :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    </el-form-item>
    <div class="el-form-item__content">
      <div class="el-input">
        <app-input
          type="date"
          placeholder="Pick a day" 
          v-on:change="datePickerChange"
          v-model="currentField.componentValue"
          v-bind="attributesBinding"
        />
      </div>
    </div>
  </div>
</template>

<script>

import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import moment from "moment";
export default {
  name: 'DatePicker',
  props: ['currentField'],
  data() {
    return {
      // date: ''
    };
  },
  methods: {
    datePickerChange(value) {
      this.currentField.componentValue = value;
    }
  },
  computed: {
    formattedValue() {
      const val = this.currentField.componentValue;
      if (!val) return '';
      const df = this.$store.state.settings.dateFormat || 'DD-MM-YYYY';
      return moment(val).format(df);
    },
    attributesBinding() {
      var attr = {};

      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    }
  },
};
</script>
<style>

@media (min-width: 768px) {
  .date-pick .date-picker-input {
    max-width: 50% !important;
  }
}
</style>
